import $ from 'jquery';

let body = $('body');
let menu_trigger = $('.menu-trigger');
let nav_menu = $('.footer-menu');

function bone_menu()
{
	if( body.hasClass('menu-open') )
	{
		body.removeClass('menu-open');
		menu_trigger.removeClass('active');
		menu_trigger.find('.icon').text('+');
		nav_menu.slideUp(400, function()
		{
			$(this).removeClass('active');
		});
	}
	else
	{
		body.addClass('menu-open');
		menu_trigger.addClass('active');
		menu_trigger.find('.icon').text('\u2012');
		nav_menu.slideDown(400, function()
		{
			$(this).addClass('active');
		});

		$('.body-wrapper').one('click', function()
		{
			body.removeClass('menu-open');
			menu_trigger.removeClass('active');
			menu_trigger.find('.icon').text('+');
			nav_menu.slideUp(400, function()
			{
				$(this).removeClass('active');
			});
		});
	}
}

export function menu()
{
	$('.menu-trigger').on('click', bone_menu);

	$('.menu-item a').on('click', function()
	{
		body.removeClass('menu-open scrolled');
	});
}

export function menu_scroll()
{
	$(window).on('scroll', function()
	{
		let scroll_top 	  = $(window).scrollTop();
		let window_height = $(window).innerHeight();

		if ( scroll_top > 20 )
		{
			body.addClass('scrolled');
		} else
		{
			body.removeClass('scrolled menu-open');
			menu_trigger.removeClass('active');
			menu_trigger.find('.icon').text('+');
			nav_menu.slideUp(400);
		}
	});

	//Call it on page load
	$(window).scroll();
}



// WEBPACK FOOTER //
// ./scripts/modules/menu.js